import { ReactNode } from "react";
import { useIsMobile } from "@/hooks/use-mobile";

interface ProfileLayoutProps {
  main: ReactNode;
  sidebar: ReactNode;
  history: ReactNode;
}

const ProfileLayout = ({ main, sidebar, history }: ProfileLayoutProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="max-w-7xl mx-auto p-4 pb-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* mobile view */}
        {isMobile && (
          <>
            <div className="md:col-span-2">
              {main}
              {sidebar}
              {history}
            </div>
          </>
        )}

        {/* desktop view */}
        {!isMobile && (
          <>
            <div className="md:col-span-2">
              {main}
              {history}
            </div>
            <div className="space-y-6">{sidebar}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProfileLayout;